import React, { useContext } from 'react';
import { Stack, Chip, Tooltip, Box } from '@mui/material';
import { usePrefaceEditorContext } from './context';
import { DraftManualDetailContext } from '../context';
import useHasAccreditationSolution from 'views/App/Portal/AWB/_hooks/useHasAccreditationSolution';

interface PrefaceTagsProps {
  prefaceId: string;
}

const PrefaceTags: React.FC<PrefaceTagsProps> = React.memo(({ prefaceId }) => {
  const { accreditationTags } = usePrefaceEditorContext();
  const { showAccreditationTags, manual } = useContext(DraftManualDetailContext);
  const hasAwbSubscription = useHasAccreditationSolution(undefined, manual?.manualLevel);

  if (
    !showAccreditationTags ||
    !hasAwbSubscription ||
    !accreditationTags[prefaceId]?.length
  ) {
    return null;
  }

  const tags = accreditationTags[prefaceId];
  const visibleTags = tags.slice(0, 2);
  const remainingTags = tags.slice(2);

  return (
    <Stack
      direction='row'
      spacing={3}
    >
      {visibleTags.map((tag: string, index: number) => (
        <Chip
          key={`preface_accreditation_tag_${index}`}
          label={tag}
          variant='filled'
          color='info'
        />
      ))}
      {remainingTags.length > 0 && (
        <Tooltip
          title={
            <Box>
              {remainingTags.map((tag: string, index: number) => (
                <Box key={`preface_tag_tooltip_${index}`}>{tag}</Box>
              ))}
            </Box>
          }
          placement='top'
        >
          <Chip
            label={`+${remainingTags.length}`}
            variant='filled'
            color='info'
          />
        </Tooltip>
      )}
    </Stack>
  );
});

export default PrefaceTags;
